<template>
<moo-dialog custom-class="email-send-common-dialog email-send-dialog" :append-to-body="true" :visible.sync="visible" width="688px" :before-close="() => handleEmailSendDialog(false)" :close-on-click-modal="false" :close-on-press-escape="false">
    <EmailTop @closeSend="closeSend"></EmailTop>
    <div class="content">
      <div class="title">
        <PrefixTitle :isRequire="true" :title="$t('主题#!!!#src/pages/H5/Cloud/components/email/EmailSend.vue_1')"></PrefixTitle>
        <moo-input v-model="meetingTitle" :placeholder="$t('请输入邮件主题#!!!#src/pages/H5/Cloud/components/email/EmailSend.vue_1')" class="input-title"></moo-input>
      </div>
      <div class="receive">
        <PrefixTitle :isRequire="true" :title="$t('收件人#!!!#src/pages/H5/Cloud/components/email/EmailSend.vue_1')"></PrefixTitle>
        <moo-checkbox v-model="isSendInitiator">{{$t("发起人#!!!#src/pages/H5/Cloud/components/email/EmailSend.vue_1")}}</moo-checkbox>
        <moo-checkbox v-model="isSendParticipant">{{$t("参会人#!!!#src/pages/H5/Cloud/components/email/EmailSend.vue_1")}}</moo-checkbox>
        <moo-checkbox v-model="isSendCharge">{{$t("事项负责人#!!!#src/pages/H5/Cloud/components/email/EmailSend.vue_1")}}</moo-checkbox>
        <moo-checkbox v-model="isSendReceiveOutside">{{$t("外部人员#!!!#src/pages/H5/Cloud/components/email/EmailSend.vue_1")}}</moo-checkbox>
      </div>
      <div class="receive-other">
        <PrefixTitle :title="$t('其他人员#!!!#src/pages/H5/Cloud/components/email/EmailSend.vue_1')"></PrefixTitle>
        <EmailInput :placeholder="$t('请输入姓名#!!!#src/pages/H5/Cloud/components/email/EmailSend.vue_1')" ref="receiveOther"></EmailInput>
      </div>
      <div v-if="isSendReceiveOutside" class="receive-outside">
        <PrefixTitle :title="$t('外部人员#!!!#src/pages/H5/Cloud/components/email/EmailSend.vue_2')"></PrefixTitle>
        <moo-input v-model="sendOtherUser" :placeholder="$t('请输入邮箱地址，并以英文分号隔开#!!!#src/pages/H5/Cloud/components/email/EmailSend.vue_1')" class="input-title"></moo-input>
      </div>
      <div class="copy">
        <PrefixTitle :title="$t('抄送人#!!!#src/pages/H5/Cloud/components/email/EmailSend.vue_1')"></PrefixTitle>
        <moo-checkbox v-model="isCopyInitiator">{{$t("发起人#!!!#src/pages/H5/Cloud/components/email/EmailSend.vue_2")}}</moo-checkbox>
        <moo-checkbox v-model="isCopyParticipant">{{$t("参会人#!!!#src/pages/H5/Cloud/components/email/EmailSend.vue_2")}}</moo-checkbox>
        <moo-checkbox v-model="isCopyCharge">{{$t("事项负责人#!!!#src/pages/H5/Cloud/components/email/EmailSend.vue_2")}}</moo-checkbox>
        <moo-checkbox v-model="isSendCopyOutside">{{$t("外部人员#!!!#src/pages/H5/Cloud/components/email/EmailSend.vue_3")}}</moo-checkbox>
      </div>
      <div class="copy-other">
        <PrefixTitle :title="$t('其他人员#!!!#src/pages/H5/Cloud/components/email/EmailSend.vue_2')"></PrefixTitle>
        <EmailInput :placeholder="$t('请输入姓名#!!!#src/pages/H5/Cloud/components/email/EmailSend.vue_2')" ref="copyOther"></EmailInput>
      </div>
      <div v-if="isSendCopyOutside" class="copy-outside">
        <PrefixTitle :title="$t('外部人员#!!!#src/pages/H5/Cloud/components/email/EmailSend.vue_4')"></PrefixTitle>
        <moo-input v-model="copyOtherUser" :placeholder="$t('请输入邮箱地址，并以英文分号隔开#!!!#src/pages/H5/Cloud/components/email/EmailSend.vue_2')" class="input-title"></moo-input>
      </div>
      <div v-if="loading" class="loading-box">
        <img width="60px" height="60px" src="https://m.elongstatic.com/toca-cloud/product/loading3.gif">
      </div>
    </div>
    <EmailBottom :loading="loading" @sendEmail="sendEmail" @previewEmail="previewEmail"></EmailBottom>
  </moo-dialog>
</template>

<script>
import EmailTop from "./EmailTop.vue";
import EmailBottom from "./EmailBottom.vue";
import PrefixTitle from "./PrefixTitle.vue";
import EmailInput from "./EmailInput.vue";

export default {
  name: "EmailSend",
  props: {
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    fileId: {
      type: String,
      default() {
        return "";
      },
    },
    fileTitle: {
      type: String,
      default() {
        return "";
      },
    },
  },
  emits: ["sendEmail", "previewEmail", "closeSend"],
  components: {
    PrefixTitle,
    EmailTop,
    EmailBottom,
    EmailInput,
  },
  data() {
    return {
      visible: false,
      meetingTitle: "",
      //receive
      isSendInitiator: true, // 收件人-》发起人
      isSendParticipant: true, // 收件人-》参与人
      isSendCharge: true, // 收件人-》事项负责人
      isSendReceiveOutside: false, // 收件人-》外部人员
      sendOtherUser: "",
      //copy
      isCopyInitiator: false, // 收件人-》发起人
      isCopyParticipant: false, // 收件人-》参与人
      isCopyCharge: false, // 收件人-》事项负责人
      isSendCopyOutside: false,
      copyOtherUser: "",
    };
  },
  computed: {},
  methods: {
    closeSend() {
      this.$emit("closeSend");
      this.handleEmailSendDialog(false);
    },
    handleEmailSendDialog(value) {
      this.visible = value;
    },
    handleEmailData() {
      let data = {};
      data.emailSubject = this.meetingTitle;
      data.emailBody = "";
      //send
      data.toCreator = this.isSendInitiator;
      data.toJoinUser = this.isSendParticipant;
      data.toFileId = this.isSendCharge === true ? this.fileId : "";
      const sendOtherUsers = this.$refs.receiveOther
        .getAllTags()
        .map((item) => {
          return {
            spaceId: item.spaceId,
            userId: item.userId,
            memberuniqueId: item.id,
          };
        });
      data.toOthers = sendOtherUsers;
      data.toOutsiders = this.sendOtherUser
        .split(";")
        .filter((item) => item.length > 0);
      //copy
      data.ccCreator = this.isCopyInitiator;
      data.ccJoinUser = this.isCopyParticipant;
      data.ccFileId = this.isCopyCharge === true ? this.fileId : "";
      const copyOtherUsers = this.$refs.copyOther.getAllTags().map((item) => {
        return {
          spaceId: item.spaceId,
          userId: item.userId,
          memberuniqueId: item.id,
        };
      });
      data.ccOthers = copyOtherUsers;
      data.ccOutsiders = this.copyOtherUser
        .split(";")
        .filter((item) => item.length > 0);
      return data;
    },
    sendEmail() {
      //   if (this.meetingTitle.length <= 0) {
      //     this.$message.error("请填写邮件主题");
      //     return;
      //   }

      this.$emit("sendEmail", this.handleEmailData());
    },
    previewEmail() {
      this.$emit("previewEmail", this.handleEmailData());
    },
  },
  mounted() {
    this.meetingTitle = this.fileTitle;
  },
};
</script>

<style lang="scss" scoped>
.email-send-common-dialog {
  border-radius: 16px !important;
}
.email-send-dialog {
  .moo-dialog__body {
    .content {
      margin: 24px;
      position: relative;

      .loading-box {
        background-color: #00000000;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .title {
        display: flex;
        align-items: center;
        width: 100%;
        height: 32px;
        margin-bottom: 16px;
      }
      .receive {
        display: flex;
        align-items: center;
        width: 100%;
        height: 32px;
        margin-bottom: 16px;
      }
      .receive-other {
        display: flex;
        align-items: center;
        width: 100%;
        min-height: 32px;
        margin-bottom: 16px;
      }
      .receive-outside {
        display: flex;
        align-items: center;
        width: 100%;
        min-height: 32px;
        margin-bottom: 16px;
      }

      .copy {
        display: flex;
        align-items: center;
        width: 100%;
        height: 32px;
        margin-bottom: 16px;
      }

      .copy-other {
        display: flex;
        align-items: center;
        width: 100%;
        min-height: 32px;
        margin-bottom: 16px;
      }

      .copy-outside {
        display: flex;
        align-items: center;
        width: 100%;
        min-height: 32px;
      }
    }
  }
}
</style>

<style lang="scss">
.email-send-dialog {
  .moo-dialog__body {
    .content {
      .title,
      .receive-outside,
      .copy-outside {
        .input-title {
          width: calc(100% - 56px);
          height: 32px;
          box-sizing: border-box;
          background: #ffffff;
          border-radius: 4px;
          .moo-input__inner {
            height: 32px !important;
            color: #222329 !important;
            border: 1px solid #e8e9ee !important;
            line-height: 32px !important;
            caret-color: #5c70ff !important;
            padding: 0px 12px;
          }
        }
      }

      .moo-checkbox {
        .moo-checkbox__input {
          width: 16px;
          height: 16px;

          &.is-checked {
            .moo-checkbox__inner {
              border-color: #5c70ff;
              background-color: #5c70ff;
            }
          }
        }
        .moo-checkbox__label {
          padding-left: 8px;
          font-weight: 400;
          font-size: 14px;
          color: #222329;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
